<template>
  <div class="viewport viewport-with-top-nav viewport-compact">
    <TopNav></TopNav>
    <div class="display-1 py-3">{{ $t('LoanPaymentCalculatorPage.title') }}</div>
    <div class="form-group mb-3">
      <label for="shiftInDays">{{ $t('LoanPaymentCalculatorPage.whenDoYouWantToPay') }}</label>
      <select class="custom-select" id="shiftInDays" v-model="shiftInDays" :disabled="loading">
        <option :value="0" :key="0">{{ expectedDateLabel }}</option>
        <option :value="index" v-for="index in daysRange" :key="index">{{ $d(getDate(index), 'short') }}</option>
      </select>
    </div>
    <div v-if="payOnExpectedDate" v-html="$t(paymentMessage, { amount: $n(expectedToBePaid, 'currency') })"
         id="late-payment-calculator-pay-on-time" />
    <div v-else>
      <div v-if="loading" class="text-center">
        <spinner></spinner>
      </div>
      <template v-else-if="!error">
        <div id="next-payment-info-message">
          <p v-html="$t('LoanPaymentCalculatorPage.latePaymentMessage')"></p>
        </div>
        <table id="next-payment-info" class="table table-sm table-escape-container">
          <tbody>
            <tr id="next-payment-info-principal">
              <td class="small text-muted border-0">{{ $t('LoanPaymentCalculatorPage.principal') }}</td>
              <td class="small text-muted border-0 text-right">{{ $n(this.amountCalculations.principal, 'currency') }}</td>
            </tr>
            <tr id="next-payment-info-primaries">
              <td class="small text-muted">{{ $t('LoanPaymentCalculatorPage.primaries') }}</td>
              <td class="small text-muted text-right">{{ $n(this.amountCalculations.primaries, 'currency') }}</td>
            </tr>
            <tr id="next-payment-info-secondaries">
              <td class="small text-muted">{{ $t('LoanPaymentCalculatorPage.secondaries') }}</td>
              <td class="small text-muted text-right">{{ $n(this.amountCalculations.secondaries, 'currency') }}</td>
            </tr>
            <tr id="next-payment-info-total-amount">
              <td>{{ $t('LoanPaymentCalculatorPage.totalDept') }}</td>
              <td class="text-right"><strong>{{ $n(this.amountCalculations.nextPaymentAmount, 'currency') }}</strong></td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
    <div class="flex-grow-1"></div>
  </div>
</template>

<script>
  import TopNav from '@shared/components/TopNav'

  export default {
    name: 'LoanPaymentCalculatorPage',
    components: { TopNav },
    data () {
      return {
        loading: false,
        error: false,
        reference: this.$route.params.reference,
        expectedDate: this.$route.params.expectedDate,
        expectedToBePaid: this.$route.params.amount,
        shiftInDays: 0,
        daysRange: 30,
        delayed: this.$route.params.loanStatus === 'delayed',
        amountCalculations: {}
      }
    },
    created() {
      this.calculate()
    },
    computed: {
      paymentMessage() {
        return this.delayed ? 'LoanPaymentCalculatorPage.lateMessage' : 'LoanPaymentCalculatorPage.onTimeMessage'
      },
      expectedDateLabel() {
        if (!this.delayed) {
          return this.$t('LoanPaymentCalculatorPage.onTime', { date: this.$d(this.expectedDate, 'short') })
        } else {
          return this.$d(this.expectedDate, 'short')
        }
      },
      payOnExpectedDate() {
        return this.shiftInDays === 0
      }
    },
    methods: {
      getDate(shift) {
        const date = new Date(this.expectedDate)
        date.setDate(date.getDate() + shift)
        return date
      },
      calculate() {
        if (this.payOnExpectedDate) {
          return
        }

        this.loading = true
        this.error = false
        return this.$http.get(`/api/loans/${this.reference}/next-payment-amount/${this.expectedDate}/${this.shiftInDays}`)
          .then((res) => {
            this.amountCalculations = res.data
          })
          .catch(() => {
            this.error = true
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    watch: {
      shiftInDays() {
        this.calculate()
      }
    }
  }
</script>
